import React from 'react';
import { tt } from '../i18n';
import { openBotLink, closeMiniApp } from '../utils/telegramWebApp';

const box = { maxWidth: 420, margin: '0 auto', padding: 24, textAlign: 'center' };
const btn = { display: 'block', width: '100%', padding: '12px 16px', margin: '10px 0', borderRadius: 10, border: 'none', cursor: 'pointer', fontSize: 16 };

export default function TelegramNotLinked({ botUsername, onLogin }) {
  const link = botUsername ? `https://t.me/${botUsername}?start=link` : null;
  return (
    <div style={box}>
      <h2>{tt('Telegram не привязан к аккаунту')}</h2>
      <p>{tt('Способ 1: откройте бота и в чате нажмите «Поделиться контактом» — аккаунт привяжется по номеру телефона.')}</p>
      {link && <button type="button" className="buttonLogin" style={btn} onClick={() => openBotLink(link)}>{tt('Открыть бота')}</button>}
      <button type="button" style={btn} onClick={closeMiniApp}>{tt('Закрыть')}</button>
      <p>{tt('Способ 2: войдите по телефону и паролю, затем в Профиле → Telegram нажмите «Привязать». Автоматической привязки нет.')}</p>
      <button type="button" style={btn} onClick={onLogin}>{tt('Войти по паролю')}</button>
    </div>
  );
}
